// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"NoData_iconWrapper__3vMVu"};